export const view = {
    methods:{
        submit: function(){
            var _self = this;
            var parameters = this.getFormModel('PasswordChange');
            parameters.FranchiseID = localStorage.franchiseID;
            parameters.MembershipUserID = localStorage.userMembershipID;

            this.$ooApi.orders.accounts.password.update.v1(parameters).then(function(){
                _self.$router.push('Profile');
            })
        }
    }
}